export default __webpack_public_path__ + "static/media/motor3.eef0f52b.png";